
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import Table from "./index";
export const columns = [{
  key: "col1",
  label: "No."
}, {
  key: "col2",
  label: "Lorem"
}, {
  key: "col3",
  label: "Ipsum"
}, {
  key: "col4",
  label: "Dolor"
}];
export const data = [{
  col1: "1",
  col2: "Et fugiat",
  col3: "Voluptate dolore",
  col4: "979"
}, {
  col1: "2",
  col2: "Quis deserunt",
  col3: "Aliqua sint laboris ut",
  col4: "814"
}, {
  col1: "3",
  col2: "Voluptate dolore",
  col3: "Aliqua sint laboris ut",
  col4: "436"
}];
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  columns,
data
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1>{`Table`}</h1>
    <h2>{`Example`}</h2>
    <Table columns={columns} data={data} mdxType="Table" />
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Table columns={columns} data={data} mdxType="Table" />
    </Preview>
    <h3>{`Table with borders`}</h3>
    <Preview mdxType="Preview">
  <Table columns={columns} data={data} type="bordered" mdxType="Table" />
    </Preview>
    <h3>{`Table without borders`}</h3>
    <Preview mdxType="Preview">
  <Table columns={columns} data={data} type="clean" mdxType="Table" />
    </Preview>
    <h3>{`Striped table`}</h3>
    <Preview mdxType="Preview">
  <Table columns={columns} data={data} striped mdxType="Table" />
    </Preview>
    <h3>{`Table with borders and without header`}</h3>
    <p>{`Table doesn't have header, if `}<inlineCode parentName="p">{`headDisabled`}</inlineCode>{` is set or all labels in `}<inlineCode parentName="p">{`columns`}</inlineCode>{` data object are empty.`}</p>
    <Preview mdxType="Preview">
  <Table columns={columns} data={data} type="bordered" headDisabled mdxType="Table" />
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Table />" component={Table} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`Tables, if build correctly, are accessible out of the box. Current implementation only supports `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/tutorials/tables/one-header/"
      }}>{`one horizontal table header`}</a>{` and no table footer.`}</p>
    <p>{`Authors should `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/tutorials/tables/caption-summary/"
      }}>{`provide context to help users understand the table data`}</a>{`.`}</p>
    <p>{`Note: Never EVER use tables for layout of non-tabular data. It's not 1999 anymore.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;